import React from 'react';
import load from '../hocs/load';
var BalancesMenuContainer = load(function () {
  return import('../components/BalancesMenu/BalanceMenuContainer');
});
var WalletDetailsBackButtonComponent = load(function () {
  return import('../components/WalletDetails/WalletDetailsBackButtonComponent');
});
var FixedLeftFluidLayout = load(function () {
  return import('../layouts/FixedLeftFluidLayout/FixedLeftFluidLayout');
});
var TradingLayout = load(function () {
  return import('../layouts/TradingLayout/TradingLayoutContainer');
});
var SingleFluidHeaderFixedContentLayout = load(function () {
  return import('../layouts/SingleFluidHeaderFixedContent/SingleFluidHeaderFixedContent');
});
var ComponentRowSingle = load(function () {
  return import('../layouts/ComponentRow/ComponentRowSingle');
});
var WalletCardGridContainer = load(function () {
  return import('../components/WalletCards/WalletCardGridContainer');
});
var WalletRowListContainer = load(function () {
  return import('../components/WalletRows/WalletRowListContainer');
});
var PageFooterComponent = load(function () {
  return import('../components/PageFooter/PageFooterComponent');
});
var WalletDetailsLayout = load(function () {
  return import('../layouts/WalletDetailsLayout/WalletDetailsLayout');
});

// context.t('Trading')
// context.t('Wallets')
// context.t('Settings')
export var mainNavOptions = {
  mainNavItems: [{
    text: 'Trading',
    icon: 'trading',
    path: '/trading'
  }, {
    text: 'Wallets',
    icon: 'wallet',
    path: '/wallets'
  }, {
    text: 'Settings',
    icon: 'settings',
    path: '/settings/profile'
  }],
  settingsPath: '/settings/profile'
};
export var subNavItems = [];
export var walletsPath = '/wallets';
export var walletDetailPath = '/wallets/wallet-detail';
export var routesArray = [{
  path: '/trading',
  render: function render() {
    return React.createElement(TradingLayout, null);
  }
}, {
  exact: true,
  path: '/wallets',
  render: function render() {
    return React.createElement(SingleFluidHeaderFixedContentLayout, {
      footer: React.createElement(PageFooterComponent, null)
    }, React.createElement(ComponentRowSingle, {
      header: 'Funded Accounts',
      component: React.createElement(WalletCardGridContainer, {
        detailsLink: walletDetailPath
      })
    }), React.createElement(ComponentRowSingle, {
      customClass: 'container-with-shadow',
      header: 'Unfunded Accounts',
      component: React.createElement(WalletRowListContainer, {
        detailsLink: walletDetailPath
      })
    }));
  }
  // this.context.t('Funded Accounts')
  // this.context.t('Unfunded Accounts')
}, {
  path: '/wallets/wallet-detail',
  render: function render() {
    return React.createElement(FixedLeftFluidLayout, {
      left: [React.createElement(WalletDetailsBackButtonComponent, {
        key: '1'
      }), React.createElement(BalancesMenuContainer, {
        key: '2'
      })]
    }, React.createElement(WalletDetailsLayout, null));
  }
}];